import { Component, OnInit, Input } from '@angular/core';
import { Product } from '../../../interfaces/product.interface';
import { PlanAttributes, SummaryView } from '../../../interfaces/plan-attributes.interface';

@Component({
    selector: 'app-compare-plan-card',
    templateUrl: './compare-plan-card.component.html',
    styleUrls: ['./compare-plan-card.component.scss'],
    standalone: false
})
export class ComparePlanCardComponent implements OnInit {

  @Input() plan: Product<PlanAttributes, SummaryView>;
  @Input() enrollStartUrl: string;
  @Input() specialEnrollmentUrl: string;
  @Input() isSep: string;

  constructor() { }

  ngOnInit() {
  }


}
